import 'bootstrap/js/dist/dropdown';
class EdiNavigation {
    constructor() {
        this.scrollProgressBar();
        //this.resizeWindow();
    }
    // resizeWindow(){
    //     $(window).on('resize', () => {
    //         $("div.scroll-progress-content").each(function (index) {
    //             $('.progressBar li').removeClass('active');
    //             $('.progressBar li').removeClass('current');
    //             $('.progressBar li').removeClass('passive');
    //         });
    //         this.scrollProgressBar();
    //     });
    // }
    scrollProgressBar(){
        var firstnode = $("#firstnode").val();
        //console.log(firstnode);

        if($(".edi-report-new .card-text-image button").hasClass('d-none'))
            $(".edi-report-new .card-text-image button").removeClass('d-none');

        $(".progressBar ul.dropdown-menu li").click(function () {
            $(".progressBar button").find('span').html($(this).find('em').html());
        });
            
        $(".progressBar a").click(function () {
            var IdName = $(this).attr("href");
            $(".progressBar li").removeClass('current');
            $("[href='" + IdName + "']")
                      .parent("li")
                      .addClass("active current");
            if ($(window).width() < 768){
                $("html, body").animate(
                    {
                            scrollTop: $(IdName).offset().top - 160,
                    },
                    800
                );
            }else{
                $("html, body").animate(
                    {
                            scrollTop: $(IdName).offset().top - 180,
                    },
                    800
                );
            }
        });
        $(".progressBar button").click(function () {
            if ($(this).attr("aria-expanded") == "false") {
                $("html, body").animate(
                    {
                        scrollTop: $(firstnode).offset().top,
                    },
                    200
                );
            }
            $(".progressBar button").find('span').html($(".progressBar ul.dropdown-menu li:first").find('em').html());
        });
            
            

            $(window).scroll(function () {
                var a = window.innerHeight + window.scrollY;
                var b = document.body.offsetHeight;
                var c = a >= b;
                var percent=0;

                $('.progressBar li:first').addClass('active');
                
                var CurrentPosition = $(this).scrollTop();
                //console.log('here');
                $("div.scroll-progress-content").each(function (index) {
                    
                  var SectionTop = $(this).offset().top - 320;
                  var SectionLength = $(this).height();
                  var SectionBottom = SectionTop + SectionLength;
                  var i = index;//$(this).index();
                  var IdSection = $(this).attr("id");
                  $('.progressBar li:first').addClass('active');
                  //console.log(i);
                  if(CurrentPosition > (SectionTop)){
                    $("[href='#" + IdSection + "']")
                      .parent("li")
                      .addClass("passive");
                      $("[href='#" + IdSection + "']")
                      .parent("li")
                      .addClass("active");
                  }
              
                  if (CurrentPosition >= SectionTop && CurrentPosition <= SectionBottom) {
                    percent = ((CurrentPosition - SectionTop) / SectionLength) * 100;
                    //console.log("i: "+i+" top: "+SectionTop+" Current: "+CurrentPosition+ " sectionlength: "+SectionLength+ " Percent: "+percent);
                    $("[href='#" + IdSection + "']")
                      .parent("li")
                      .addClass("active");
                    $("[href='#" + IdSection + "']")
                      .parent("li")
                      .addClass("current");
                  } else if (CurrentPosition >= SectionBottom) {
                    percent = 100;
                    $("[href='#" + IdSection + "']")
                      .parent("li")
                      .removeClass("current");
                  } else {
                    $("[href='#" + IdSection + "']")
                      .parent("li")
                      .removeClass("active");
                    $("[href='#" + IdSection + "']")
                      .parent("li")
                      .removeClass("passive");
                    $("[href='#" + IdSection + "']")
                      .parent("li")
                      .removeClass("current");
                  }
                  
                  $(".progressBar button").find('span').html($(".progressBar ul.dropdown-menu li.current").find('em').html());

                  if (c) {
                    percent = 100;
                  }
                  $(".rs").text(c + "|" + percent);
                  $(".dropdown-menu li.active:eq(" + i + ") span").css("height", percent + "%");
                  // if ($(window).width() < 768) {
                  // } else {
                  //   //console.log(percent);
                  //   $(".dropdown-menu li.active:eq(" + i + ") span").css({"width" : percent + "%"});
                  // }
                });
              });





    }
}

export default EdiNavigation;
new EdiNavigation;
